import { DataDeliveryAdminOrganizationMetadataService, OrganizationMetadataDTO } from '@om1/falcon-api'
import { handleApiError } from '@om1/falcon-api/utils'
import { call, put } from 'redux-saga/effects'
import { generalSettingsActions } from '../state/general-settings'

export function createUpdateOrganizationSettingsSaga() {
    return function* (action: ReturnType<typeof generalSettingsActions.updateOrganizationSettings>) {
        try {
            yield put(generalSettingsActions.setOrganizationSettingsSaving({ saving: true }))
            const updatedMetadata: OrganizationMetadataDTO = yield call(
                DataDeliveryAdminOrganizationMetadataService.patchDataDeliveryOrganizationMetadataOrganizationMetadataIdPatch,
                {
                    organizationMetadataId: action.payload.id,
                    requestBody: action.payload.data
                }
            )
            yield put(generalSettingsActions.updateOrganizationSettingsSuccess({ organizationMetadata: updatedMetadata }))
        } catch (error) {
            yield handleApiError(error)
        } finally {
            yield put(generalSettingsActions.setOrganizationSettingsSaving({ saving: false }))
        }
    }
}
